import React from "react";
import Artwork from '../Artwork';
import "./freemium-carousel.scss";
import ReactDOM from 'react-dom';
import { sendArtworks, getFirstTime, getQualityFlag, getMuteFlag } from '../../pages/utils.js'

export default class FreemiumCarousel extends React.Component {
  constructor(props) {
    super(props);
    const { playlist } = props;
    this.state = {
      current: parseInt(playlist.artworks ? playlist.artworks.length / 2 : 0),
      artworks: playlist.artworks,
      playlistName: playlist.name,
      artNo: 2,
      highquality: "high",
      listGetFocus: ""
    }
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    if (!getFirstTime()) {
      setTimeout(() => { ReactDOM.findDOMNode(this.refs.carosel).focus(); }, 800);
    }
    this.checkQuality();
  }

  setList() {
    let { current, artworks } = this.state;
    if (current == artworks.length - 1 || current == artworks.length - 2) {
      var newArray = this.state.artworks.slice();
      for (let i = 0; i < artworks.length; i++) {
        newArray.push(artworks[i]);
        this.setState({
          artworks: newArray
        })
      }
    }
  }

  checkQuality() {
    if (getQualityFlag()) {
      if (screen.width >= 4096 || screen.height >= 4096) {
        this.setState({
          highquality: "4kuhd"
        })
      }
      else if (screen.width >= 3840 || screen.height >= 3840) {
        this.setState({
          highquality: "4k"
        })
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { playlist } = nextProps;
    this.state = {
      current: playlist.artworks ? parseInt(playlist.artworks.length / 2) : 0,
      artworks: playlist.artworks,
      playlistName: playlist.name
    }
    setTimeout(() => { ReactDOM.findDOMNode(this.refs.carosel).focus(); this.setList(); }, 400);
  }

  handleKeyDown(e) {
    switch (e.which) {
      case 13:
        sendArtworks(this.state.artworks, this.state.playlistName, this.state.highquality, getMuteFlag() || "false", "false", this.state.current, "true");
        break;
      case 37:
        this.prev();
        break;
      case 39:
        this.next();
        break;
    }
  }

  next() {
    this.setState({
      artNo: 2
    })
    // let { current } = this.state;
    const { artworks } = this.state;
    // current += 1;
    // if (current == artworks.length - 2 || current == artworks.length - 1) {
      var newArray = this.state.artworks.slice(0);
      // for (let i = 0; i < artworks.length; i++) {
        newArray.push(newArray.shift());
        this.setState({
          artworks: newArray
        })
      // }

    // }
    // this.setState({ current });
  }

  prev() {
    const slides = this.state.artworks.slice(0);
    slides.unshift(slides.pop());
    this.setState({artworks:slides});
    // this.setState({
    //   artNo: 1
    // })
    // let { current } = this.state;
    // const { artworks } = this.state;
    // current -= 1;
    // let k = artworks.length;
    // if (current == 1 || current == 0) {
    //   var newArray = this.state.artworks.slice();
    //   for (let i = k - 1; i >= 0; i--) {
    //     newArray.unshift(artworks[i]);
    //     this.setState({
    //       artworks: newArray
    //     })
    //     current++;
    //   }
    // }
    // this.setState({ current });
  }

  render() {
    const { current, artNo } = this.state;
    const { artworks } = this.state || {};
    if (!artworks) {
      return null
    }
    let left = (- current * 50) - 25;
    const slides = artworks.map((item, idx) => {
      left += 50;
      return (
        <div key="idx" className="freemium-carousel__slide" style={{ left: `${left}%` }}>
          <Artwork key={idx} hasFocus={this.state.listGetFocus} showDetails={idx == current} artwork={item} showImage={artNo == 2 ? idx >= current - 2 && idx <= current + 2 : idx >= current - 1 && idx <= current + 2} />
        </div>
      );
    });

    return (
      <div
        tabIndex="1"
        ref='carosel'
        className="freemium-carousel"
        onKeyDown={this.handleKeyDown}
        onFocus={() => this.setState({ listGetFocus: true })}
        onBlur={() => this.setState({ listGetFocus: false })}
      >
        {slides}
      </div>
    );
  }
}
